// export interface control{
//   controlItem[]
// }

export interface controlItem {
  name?: string
  type?: number // 参考 ESEARCH_TYPE
  label?: string
  list?: tag[]
  date?: boolean
  minLength?: number // 最少展示个数 超过展示 查看全部
  data?: any // 用来存所有数据
  collapse?: boolean // 用来显示查看全部 收起
  classifyType?: number // 用来获取分类数据使用
  children?: controlItem // 用来存储二级分类数据
  thirdChildren?: controlItem // 用户来存储三级分类
  level?: number // 用于对分类分级
}

export interface tag {
  label: string
  value: string
  flag: boolean
  pid?: number
  id?: number
  labelLang?: any
}

// export interface basic{
//   name:string,
//   type:string
// }

export enum ESEARCH_TYPE {
  'TAG',
  'TAG_RANGE',
}

export class TagItem {
  label: string = '全部'
  value: string | number = '全部'
  flag: boolean = true
  pid: string | number = ''
  id: string | number = ''
  labelLang: any = 'common.all'
  constructor(data?: any) {
    if (data) {
      this.label = data.label || '全部'
      this.value = data.value || '全部'
      this.flag = data.flag || true
      this.pid = data.pid || ''
      this.id = data.id || ''
      this.labelLang = data.labelLang || 'common.all'
    }
  }
}
